import { Dispatch, SetStateAction } from "react";

export enum ROUTE {
  JSON_PARSER = "json-parser",
  JSON_FORMATOR = "json-formatter",
  HTML_FORMATOR = "html-formatter",
  CSS_FORMATOR = "css-formatter",
}

export interface FormatorContextInterface {
  inputcode: string;
  setInputCode: Dispatch<SetStateAction<string>>;
  beautifiedCode: string;
  setBeautifiedCode: Dispatch<SetStateAction<string>>;
  urlType: string;
  setUrlType: Dispatch<SetStateAction<string>>;
  showJsonDataType: boolean;
  setShowJsonDataType: Dispatch<SetStateAction<boolean>>;
  showObjectSize: boolean;
  setShowObjectSize: Dispatch<SetStateAction<boolean>>;
  inputFileData: string | undefined;
  setInputFileData: Dispatch<SetStateAction<string | undefined>>;
  htmlRunView: boolean;
  sethtmlRunView: Dispatch<SetStateAction<boolean>>;
  // inputUrlData: string | null;
  // setInputUrlData: Dispatch<SetStateAction<string | null>>;
}
